<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12">
                    <ValidationProvider name="coop_cv_name" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_cv_name')">
                            <b-form-input v-model="formData.name" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>

                <b-col cols="12">
                    <ValidationProvider name="coop_cv_file" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_cv_file')">
                            <b-form-file v-model="formData.file" accept=".pdf,.doc,.docx" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>

                <b-col cols="12">
                    <ValidationProvider name="label" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('label')">
                            <parameter-selectbox v-model="formData.tag"
                                                 code="cv.tags"
                                                 :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-3">
                <b-button variant="primary" :disabled="formLoading" @click="createForm">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
    import { ValidationObserver, ValidationProvider } from 'vee-validate';
    import CoopCvService from '@/services/CoopCvService';
    import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox';

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,
            ParameterSelectbox
        },
        data() {
            return {
                formLoading: false,
                formData: {
                    name: '',
                    file: null,
                    tag: null
                }
            };
        },
        methods: {
            async createForm() {
                const isValid = await this.$refs.formModalValidate.validate();

                if (isValid) {
                    this.formLoading = true;

                    const formData = new FormData();
                    formData.append('name', this.formData.name);
                    if (this.formData.file) {
                        formData.append('file', this.formData.file);
                    }
                    if (this.formData.tag) {
                        formData.append('tag', this.formData.tag);
                    }

                    CoopCvService.store(formData)
                        .then(response => {
                            this.$toast.success(this.$t('api.' + response.data.message));
                            this.$emit('createFormSuccess', true);
                        })
                        .catch((error) => {
                            this.showErrors(error, this.$refs.formModalValidate);
                        })
                        .finally(() => {
                            this.formLoading = false;
                        });
                }
            }
        }
    };
</script>
